var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","variant":"danger","title":_vm.showToolTip ? 'Поместить в корзину' : ''},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fa fa-trash"})])
}
var staticRenderFns = []

export { render, staticRenderFns }